import { IsNotEmpty, IsOptional, IsString, MaxLength, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import BaseIvrNode from 'src/models/Ivrs/Nodes/baseIvrNode';

enum DisplayType {
  ORDER_STATUS = 'ORDER_STATUS',
}

const MESSAGE_MAX_LENGTH = 140;
const MESSAGE_TOO_LONG_ERROR_MESSASGE = 'The message exceeds the limit of 140 characters. Please shorten the message.';
const MESSAGE_EMPTY_ERROR_MESSAGE = 'Please enter a message.';

class DataDisplayConfig {
  @IsString()
  @IsNotEmpty({ message: MESSAGE_EMPTY_ERROR_MESSAGE })
  @MaxLength(MESSAGE_MAX_LENGTH, { message: MESSAGE_TOO_LONG_ERROR_MESSASGE })
  missingFulfillmentMessage: string;

  @IsString()
  @IsNotEmpty({ message: MESSAGE_EMPTY_ERROR_MESSAGE })
  @MaxLength(MESSAGE_MAX_LENGTH, { message: MESSAGE_TOO_LONG_ERROR_MESSASGE })
  missingStatusAndEtaMessage: string;

  @IsString()
  @IsNotEmpty({ message: MESSAGE_EMPTY_ERROR_MESSAGE })
  @MaxLength(MESSAGE_MAX_LENGTH, { message: MESSAGE_TOO_LONG_ERROR_MESSASGE })
  missingEtaMessage: string;
}

export default class DataDisplay extends BaseIvrNode {
  @IsString()
  @IsNotEmpty()
  displayType: DisplayType;

  @IsString()
  @IsNotEmpty()
  data: string;

  @IsString()
  @IsOptional()
  nextId?: string;

  @ValidateNested()
  @Type(() => DataDisplayConfig)
  config: DataDisplayConfig;
}
